export default function (type) {
    if ("SANS_RECOURS" === type) {
        return "Sans recours";
    } else if ("POURVOI_ORDINAIRE" === type) {
        return "Pourvoi ordinaire";
    } else if ("POURVOI_IMMEDIAT" === type) {
        return "Pourvoi immédiat";
    }
    return null;
}
